module.exports = __webpack_public_path__ + "static/media/ghanaescapes2.9f6f1d9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ghanaescapes2.jpg
// module id = 53
// module chunks = 0